import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { LangProvider } from "./context/LangContext";

// Pages
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import VerifyToken from "./pages/VerifyToken";
import Dashboard from "./pages/Dashboard";
import Screening from "./pages/Screening";
import Reports from "./pages/Reports";
import Account from "./pages/Account";
import Admin from "./pages/Admin";
import Pricing from "./pages/Pricing";
import NotFound from "./pages/NotFound";

// ── Rută publică — redirecționează la dashboard dacă e autentificat
function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <p style={{ fontFamily: "sans-serif", color: "#9ca3af" }}>Se încarcă…</p>
    </div>
  );
  return user ? <Navigate to="/dashboard" replace /> : children;
}

// ── Rută protejată — necesită autentificare
function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <p style={{ fontFamily: "sans-serif", color: "#9ca3af" }}>Se încarcă…</p>
    </div>
  );
  return user ? children : <Navigate to="/login" replace />;
}

// ── Rută admin — necesită rol admin
function AdminRoute({ children }) {
  const { user, loading, isAdmin } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (!isAdmin) return <Navigate to="/dashboard" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      {/* Public */}
      <Route path="/login"          element={<PublicRoute><Login /></PublicRoute>} />
      <Route path="/auth/callback"  element={<AuthCallback />} />
      <Route path="/verify"         element={<VerifyToken />} />
	<Route path="/pricing"  element={<Pricing />} />

      {/* Protected */}
      <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
      <Route path="/screening" element={<PrivateRoute><Screening /></PrivateRoute>} />
      <Route path="/rapoarte"  element={<PrivateRoute><Reports /></PrivateRoute>} />
      <Route path="/cont"      element={<PrivateRoute><Account /></PrivateRoute>} />

      {/* Admin */}
      <Route path="/admin"     element={<AdminRoute><Admin /></AdminRoute>} />

      {/* Redirects */}
      <Route path="/"          element={<Navigate to="/dashboard" replace />} />
      <Route path="*"          element={<NotFound />} />
    </Routes>
  );
}

export default function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
    </LangProvider>
  );
}
